import React from "react";
import "./Advantages_Video_Wala_Bus_Stand_Card.css";

function Advantages_Video_Wala_Bus_Stand_Card({ imgSrc, imgName,imgName2, imgNumber, overlayDiscription }) {
  return (
    <>
      <section className="Advantages_Video_Wala_Bus_Stand_Card">
        <div className="img-holder">
          <img
            className="stand-img"
            src={process.env.PUBLIC_URL + imgSrc}
            alt="stand-advantage-img"
          />
        </div>

        <div className="text-holder">
          <div className="name-holder">
            <p>{imgName}<br/>{imgName2}</p>
          </div>
          <div className="number-holder">
            <h4>{imgNumber}</h4>
          </div>
        </div>

        <div className="overlay-text-holder">
          <p>
           {overlayDiscription}
          </p>
        </div>

        <div className="pink-overlay-holder"></div>

        <div className="overlay-holder"></div>
      </section>
    </>
  );
}

export default Advantages_Video_Wala_Bus_Stand_Card;
